export const instagram = "https://www.instagram.com/rocketdreams_/"
export const linkedin = "https://www.linkedin.com/company/rocket-dreams/"
export const rocket = "https://rocketdreams.io/?__hstc=216044105.424207b921854af92e315c12074eee38.1674747315284.1677572462257.1678870541184.26&__hssc=216044105.2.1678870541184&__hsfp=2782025610"

export const terms= "https://www.innovationmatch.io/terms-and-conditions-it/"
export const privacy="https://www.innovationmatch.io/privacy/"
export const contact="https://www.innovationmatch.io/contact/"
export const home = "https://www.innovationmatch.io/"